import React, { useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
// import PropTypes from 'prop-types';
import clsx from 'clsx';
// import { useDetectClickOutside } from 'hooks/useDetectClickOutside';
import useMountTransition from 'hooks/useMountTransition';
import './styles.scss';

function createPortalRoot() {
  const drawerRoot = document.createElement('div');
  drawerRoot.setAttribute('id', 'drawer-root');
  return drawerRoot;
}

const Drawer = ({
  isOpen,
  show,
  dismiss,
  children,
  menuClass,
  position = 'left',
  removeWhenClosed = true,
  triggerButton,
}) => {
  // Add remaining props to passed trigger button component.
  const Button = triggerButton ? React.cloneElement(
    triggerButton,
    {
      isOpen,
      onClick: (e) => {
        e.stopPropagation();
        if (isOpen) {
          dismiss(e);
        }
        else {
          show(e);
        }
      },
    },
  ) : null;

  return (
    <>
      {Button}
      <Menu
        isOpen={isOpen}
        dismiss={dismiss}
        children={children}
        className={menuClass}
        position={position}
        removeWhenClosed={removeWhenClosed}
      />
    </>
  );
};

const Menu = ({
  isOpen,
  dismiss,
  children,
  className,
  position = 'left',
  removeWhenClosed = true,
}) => {
  const isTransitioning = useMountTransition(isOpen, 300);
  const bodyRef = useRef(window.appRootMountPoint || document.querySelector('body'));
  const portalRootRef = useRef(document.getElementById('drawer-root') || createPortalRoot());

  useEffect(() => {
    if (document.getElementById('drawer-root') === null) {
      bodyRef.current.appendChild(portalRootRef.current);
    }
    else {
      portalRootRef.current = document.getElementById('drawer-root');
    }

    const bodyEl = bodyRef.current;
    return () => {
      // Esure scroll overflow is removed;
      bodyEl.style.overflow = '';
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      bodyRef.current.style.overflow = 'hidden';
    }
    else {
      bodyRef.current.style.overflow = '';
    }
  });

  if (!isTransitioning && removeWhenClosed && !isOpen) {
    return null;
  }

  return createPortal(
    <div
      aria-hidden={isOpen ? 'false' : 'true'}
      className={clsx('drawer-container', className, {
        open: isOpen,
        in: isTransitioning,
      })}
    >
      <div
        className={clsx('drawer', position)}
        role="dialog"
      >
        {children}
      </div>
      <div
        className="backdrop"
        onClick={(e) => {
          e.stopPropagation();
          dismiss();
        }}
      />
    </div>,
    portalRootRef.current,
  );
};

export default Drawer;
